import lazy from "@codeArt/apps/lazy";
import SettingsInputSvideoIcon from '@material-ui/icons/SettingsInputSvideo';
import CategoryIcon from '@material-ui/icons/Category';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';

export function getMenus(baseUrl) {
  if (baseUrl.endsWith("/")) baseUrl = baseUrl.substr(0, baseUrl.length - 1);

  return [
    {
      name: "插件管理",
      icon: <SettingsInputSvideoIcon />,
      type: "item",
      link: `${baseUrl}/plugin/manager`
    },
    {
      name: "插件分类",
      icon: <CategoryIcon />,
      type: "item",
      link: `${baseUrl}/plugin/category`
    },
    {
      name: "插件标签",
      icon: <LocalOfferIcon />,
      type: "item",
      link: `${baseUrl}/plugin/tag`
    }
  ];
}

export function getRoutes(baseUrl) {
  if (baseUrl.endsWith("/")) baseUrl = baseUrl.substr(0, baseUrl.length - 1);

  return [
    {
      path: `${baseUrl}/plugin/manager`,
      component: lazy(() => import("@codeArt/apps/page/extension/admin/manager"))
    },
    {
      path: `${baseUrl}/plugin/category`,
      component: lazy(() => import("@codeArt/apps/page/extension/admin/category"))
    },
    {
      path: `${baseUrl}/plugin/tag`,
      component: lazy(() => import("@codeArt/apps/page/extension/admin/tag"))
    },
  ]
}